<h2>Ad Details</h2>


<form [formGroup]="adForm">
  <div class="container ">
    <div class="row">
      <div class="col">
        <div class="row">
          <mat-form-field  appearance="outline">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name">
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field  appearance="outline">
            <mat-label>Description</mat-label>
            <input matInput formControlName="description">
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field  appearance="outline">
            <mat-label>Number of Days</mat-label>
            <input matInput formControlName="duration">
          </mat-form-field>
        </div>
        <div *ngIf="false" class="row">
          <mat-form-field  appearance="outline">
            <mat-label>Country</mat-label>
            <input matInput formControlName="country">
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field  appearance="outline">
            <mat-label>Redirection URL</mat-label>
            <input matInput formControlName="url">
          </mat-form-field>
        </div>

        <div class="row">
          <div style="margin-top: 20px ;">

            <label (click)="fileInput.click()" class="uploadimagetext">Image*</label>
            <br>
            <i matTooltip="For a better resolution, we recommend uploading a square picture">Recommended ratio 1:1</i>

            <input #fileInput type="file" (change)="selectFile($event)" style="display:none;" ng2FileSelect
              [uploader]="uploader" />

            <div [innerHtml]='msg' *ngIf="msg" style="color: red;"></div>
            <div>
              <img class="uploadedimage" src="https://events.globalistic.tech{{adDetails.img}}" ></div>

          </div>
        </div>
      </div>

      </div>

    </div>
  <div style="margin-top: 30px;" class="row">
      <div class="col d-flex justify-content-center" >
        <button (click)="modifyAd()" class="acceptbutton" type="submit">Modify Ad</button>
      </div>
      
  </div>
</form>